<template>
  <div class="ml-4 relative">
    <popper
      trigger="click"
      :options="{
        placement: placement,
        modifiers: {
          offset: {
            offset: '0,8px'
          }
        }
      }"
      @show="$emit('show')"
    >
      <div class="bg-white shadow-md min-w-32 z-30">
        <slot />
      </div>
      <button
        slot="reference"
        class="transition-all trainsition-normal focus:outline-none"
        :class="buttonClass ? buttonClass : 'w-4 hover:opacity-50'"
        type="button"
      >
        <slot name="icon">
          <icon
            icon="dots-vertical"
            class="w-6 h-6 icons-black"
          />
        </slot>
      </button>
    </popper>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
export default {
  name: "CardActions",
  components: {
    Popper
  },
  props: {
    placement: {
      type: String,
      required: false,
      default() {
        return 'bottom'
      }
    },
    buttonClass: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>
